"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _filtersholder = _interopRequireDefault(require("./filtersholder/filtersholder"));

var _dropdownindicator = _interopRequireDefault(require("../../dropdowns/searchabledropdown/multiselect/dropdownindicator/dropdownindicator"));

var _index = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _filtermenu_styles = _interopRequireDefault(require("./filtermenu_styles"));

var _filtermenu_definition = _interopRequireDefault(require("./filtermenu_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : MENU : FILTER ~~~~~~~~~~ ========== */


var FilterMenu =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterMenu, _Component);

  function FilterMenu(props) {
    var _this;

    _classCallCheck(this, FilterMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterMenu).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getFiltersState", function (filters) {
      var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filtersState = {};
      Object.keys(filters).forEach(function (filter) {
        return filtersState[filter] = clear ? [] : filters[filter]['initialState'];
      });
      return filtersState;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (_this.node.contains(e.target)) {
        return;
      }

      if (_this.state.menuOpen) _this.closeFiltersHolder();
    });

    _defineProperty(_assertThisInitialized(_this), "openClose", function () {
      return _this.state.menuOpen ? _this.closeFiltersHolder() : _this.openFiltersHolder();
    });

    _defineProperty(_assertThisInitialized(_this), "openFiltersHolder", function () {
      return _this.setState({
        menuOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeFiltersHolder", function () {
      return _this.setState({
        menuOpen: false,
        filters: _this.appliedFilters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (filterName, filterValue) {
      var filters = JSON.parse(JSON.stringify(_this.state.filters));
      var filterNameIndex = filters[filterName].indexOf(filterValue);
      filterNameIndex < 0 ? filters[filterName].push(filterValue) : filters[filterName].splice(filterNameIndex, 1);

      _this.setState({
        filters: filters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClearFilter", function () {
      return _this.setState({
        filters: _this.getFiltersState(_this.props.filters, true)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleApplyFilter", function () {
      _this.appliedFilters = _this.state.filters;

      _this.setState({
        menuOpen: false
      });

      _this.props.onApply(_this.state.filters);
    });

    _defineProperty(_assertThisInitialized(_this), "renderIndicatorTitle", function (activeFilters) {
      var numOfSelected = 0;

      for (var filt in activeFilters) {
        numOfSelected += activeFilters[filt].length;
      }

      return numOfSelected ? "".concat(numOfSelected, " Selected") : 'None';
    });

    _this.state = {
      menuOpen: false,
      filters: _this.getFiltersState(props.filters)
    };
    _this.appliedFilters = JSON.parse(JSON.stringify(_this.getFiltersState(props.filters)));
    return _this;
  }

  _createClass(FilterMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (Object.keys(this.props.filters).toString() !== Object.keys(prevProps.filters).toString()) {
        this.appliedFilters = JSON.parse(JSON.stringify(this.getFiltersState(this.props.filters, true)));
        this.handleClearFilter();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: "menu filtermenu ".concat((0, _index.generateClasses)(this.props), " ").concat(this.props.classes.filtermenu, " active-").concat(this.state.menuOpen),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement(_dropdownindicator.default, {
        active: this.state.menuOpen,
        title: this.renderIndicatorTitle(this.appliedFilters),
        name: "Filters",
        icon: 'sliders-h',
        toggleMenu: this.openClose
      }), _react.default.createElement(_filtersholder.default, {
        onApply: this.handleApplyFilter,
        onSelect: this.handleSelect,
        onClear: this.handleClearFilter,
        filters: this.props.filters,
        filterState: this.state.filters
      }));
    }
  }]);

  return FilterMenu;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(FilterMenu, _filtermenu_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_filtermenu_styles.default)(FilterMenu);

exports.default = _default;